<template>
	<panel-base :checked="data!==null" :ok="data===0" :loading="loading" @start="start" @stop="stop">
		<template #heading>
			Негативна консумация
			<span v-if="data!==null">
				({{ data }})
			</span>
		</template>
		<template #content v-if="data!==null">
			<neg-cons-list
				:session="session"
				:imodel="imodel"
				:utility="utility"
			></neg-cons-list>
		</template>
	</panel-base>
</template>
<script>
import expansionPanelShort from "@/ittijs/ExpansionPanelShort";
import PanelBase from "@/views/report/checks/panelBase";
import NegConsList from "@/views/report/checks/components/negConsList";
import checkMixin from "@/views/report/checks/checkMixin";

export default {
	components: {NegConsList, PanelBase},
	mixins: [
		expansionPanelShort,
		checkMixin(
			(self, getController) => self.imodel.negCons(self.session, getController)
		),
	],
	props: [
		'utility',
		'session',
		'imodel',
	],
	watch: {
		utility(){ this.reset() },
		session(){ this.reset() },
	},
}
</script>